import { Component, Input, OnInit } from '@angular/core';
import { Queue, Registration } from '../../../models';
import { QueueService } from '../../../services';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'qms-queue-pendings',
    templateUrl: './queue-pendings.component.html',
    styleUrls: ['../faculty-queues.component.css']
})
export class QueuePendingsComponent implements OnInit {

    @Input()
    public queue: Queue;

    public processingRegistrations: Observable<Array<Registration>>;
    public normalRegistrations: Observable<Array<Registration>>;
    public plannedRegistrations: Observable<Array<Registration>>;
    public children: Observable<Array<Queue>>;

    public normalRegistrationsLimit: number;
    public plannedRegistrationsLimit: number;

    constructor(private queuesService: QueueService) {
        this.normalRegistrationsLimit = 5;
        this.plannedRegistrationsLimit = 2;
    }

    ngOnInit() {
        this.load(this.queue.id);
    }

    private load(id) {
        if (this.queue.category) {
            this.children = this.queuesService.findChildrenPublic(id);
        } else {
            this.processingRegistrations = this.queuesService.findProcessingRegistrations(id);
            this.normalRegistrations = this.queuesService.findNormalPendingRegistrations(id);
            this.plannedRegistrations = this.queuesService.findPlannedPendingRegistrations(id);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/faculty-queues/queue-pendings/queue-pendings.component.ts